import { render, staticRenderFns } from "./information-education.vue?vue&type=template&id=6eca8024&scoped=true"
import script from "./information-education.vue?vue&type=script&lang=js"
export * from "./information-education.vue?vue&type=script&lang=js"
import style0 from "./information-education.vue?vue&type=style&index=0&id=6eca8024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca8024",
  null
  
)

export default component.exports